import { heydayPath, navigateToHeydayPage, pageFromPathname, subscribeToHeydayLocation } from '../../config/heydayRoutes';
import type { HeydayPage } from '../../config/heydayPageManifest';
import type { CollectionDetailRoutePort } from '../../shared/collectionDetailRoute';

type DetailHistoryEntry = { detailURL: string; returnURL: string };
const historyKey = 'heydayCollectionDetail';

/** 같은 목록은 mount를 유지하여 검색·정렬·페이지·스크롤 상태를 보존합니다. */
export function createCollectionDetailRouteAdapter(page: HeydayPage, parameter: string, exclusiveParameters: string[] = []): CollectionDetailRoutePort {
  return {
    read() {
      if (pageFromPathname(window.location.pathname) !== page) return undefined;
      return new URLSearchParams(window.location.search).get(parameter)?.trim() || undefined;
    },
    open(id) {
      if (pageFromPathname(window.location.pathname) !== page || !id.trim()) return;
      const query = new URLSearchParams(window.location.search);
      exclusiveParameters.forEach((key) => query.delete(key));
      query.set(parameter, id);
      const detailURL = heydayPath(page, query);
      const returnURL = `${window.location.pathname}${window.location.search}`;
      if (detailURL === returnURL) return;
      navigateToHeydayPage(page, query);
      window.history.replaceState({ ...window.history.state, [historyKey]: { detailURL, returnURL } }, '', detailURL);
    },
    close() {
      if (pageFromPathname(window.location.pathname) !== page) return;
      const currentURL = `${window.location.pathname}${window.location.search}`;
      const entry = window.history.state?.[historyKey] as DetailHistoryEntry | undefined;
      if (entry?.detailURL === currentURL && entry.returnURL !== currentURL) {
        window.history.back();
        return;
      }
      // 직접 받은 상세 링크에는 돌아갈 목록 이력이 없으므로 현재 entry에서 상세만 제거합니다.
      const query = new URLSearchParams(window.location.search);
      query.delete(parameter);
      navigateToHeydayPage(page, query, { replace: true });
    },
    subscribe: subscribeToHeydayLocation,
  };
}

export const staffingDetailRouteAdapter = createCollectionDetailRouteAdapter('staffing', 'change', ['planId']);
export const staffingPlanDetailRouteAdapter = createCollectionDetailRouteAdapter('staffing', 'planId', ['change']);
export const recruitingDetailRouteAdapters = {
  requisitions: createCollectionDetailRouteAdapter('requisitions', 'job'),
  candidates: createCollectionDetailRouteAdapter('candidates', 'candidate'),
  offers: createCollectionDetailRouteAdapter('offers', 'offer'),
} as const;
